if (baseUrl === undefined) {
  var baseUrl = '';
}
const maxMenuItemsDesktop = 5